export default __webpack_public_path__ + "static/media/headshot-placeholder.86b887fe.png";